'use strict';

import Map from './Map';

/**
 * Made for the search results page,
 * where there will be displayed more
 * then one marker on the map.
 */
export default class MultiLocationMap extends Map
{
    draw(bbox, distance, displaceMap) {
        super.draw(bbox, distance, displaceMap);
    }

    updateMarkers(locations) {
        const markers = [];
        let i = 0;
        for (let location of locations) {
            if (location.location !== null) {
                i++;
                markers.push({
                    position: {
                        lat: location.location.lat,
                        lng: location.location.lon
                    },
                    markerNumber: i,
                    markerText: i
                });
            }
        }
        this.addMarkers(markers);
    }
}
